(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lolxi-system"] && !Shopify.designMode) return;
  try {
    const lxMotion = matchMedia('(prefers-reduced-motion: reduce)');
const lxStrings = window.lolxiStrings || {pause:'Pause',play:'Play'};
class LxElement extends HTMLElement {
  connectedCallback(){this.controller?.abort();this.controller=new AbortController();this.mount();}
  disconnectedCallback(){this.controller?.abort();}
  on(target,event,handler){target?.addEventListener(event,handler,{signal:this.controller.signal});}
  mount(){}
}
class LxHeader extends LxElement {
  mount(){
    const toggle=this.querySelector('[data-menu-toggle]'),shop=this.querySelector('.lx-shop-menu');
    const images=this.querySelector('.lx-menu-images'),mega=this.querySelector('.lx-mega'),dock=this.querySelector('.lx-menu-dock');
    const frame=this.closest('.lx-header-frame');
    const group=frame?.closest('#header-group'),page=this.closest('.page-wrapper');this.stickyGroup=group;
    const desktopScroll=window.matchMedia('(min-width: 990px)');
    let scrollElement=null,announcementHeight=0,lastScrollY=Math.max(0,window.scrollY),direction=0,travel=0;
    const scrollPosition=()=>scrollElement?scrollElement.scrollTop:window.scrollY;
    cancelAnimationFrame(this.scrollFrame);this.scrollFrame=null;
    const syncViewport=()=>{
      const nextScrollElement=page&&desktopScroll.matches?page:null;
      if(nextScrollElement!==scrollElement){scrollElement=nextScrollElement;lastScrollY=Math.max(0,scrollPosition());direction=0;travel=0;}
      announcementHeight=[...(group?.querySelectorAll('[data-lx-announcement]')||[])].reduce((height,bar)=>height+bar.getBoundingClientRect().height,0);
      if(group){
        group.style.setProperty('--lx-announcement-height',`${announcementHeight}px`);
        if(!announcementHeight||scrollPosition()<=0)group.dataset.lxAnnouncementHidden='false';
      }
      const bounds=this.getBoundingClientRect(),compact=bounds.width<=1100;
      if(group)document.documentElement.style.setProperty('--lx-header-offset',`${bounds.height+(group.dataset.lxAnnouncementHidden==='true'?0:announcementHeight)}px`);
      const viewportHeight=window.visualViewport?.height||window.innerHeight;
      const viewportTop=window.visualViewport?.offsetTop||0;
      this.style.setProperty('--lx-menu-viewport',`${Math.max(0,viewportTop+viewportHeight-bounds.bottom)}px`);
      const destination=compact?dock:mega;
      if(images&&destination&&images.parentElement!==destination)destination.append(images);
      document.documentElement.classList.toggle('lx-menu-open',compact&&this.dataset.open==='true');
    };
    const setAnnouncementHidden=hidden=>{
      if(!group)return;
      const next=String(Boolean(hidden&&announcementHeight));
      if(group.dataset.lxAnnouncementHidden===next)return;
      group.dataset.lxAnnouncementHidden=next;syncViewport();
    };
    const updateScroll=()=>{
      this.scrollFrame=null;
      const maxScroll=Math.max(0,scrollElement?scrollElement.scrollHeight-scrollElement.clientHeight:document.documentElement.scrollHeight-window.innerHeight);
      const y=Math.max(0,Math.min(scrollPosition(),maxScroll)),delta=y-lastScrollY;lastScrollY=y;
      if(y<=1){direction=0;travel=0;setAnnouncementHidden(false);return;}
      if(this.dataset.open==='true'||shop?.open){direction=0;travel=0;return;}
      if(!delta)return;
      const nextDirection=Math.sign(delta);
      if(nextDirection!==direction){direction=nextDirection;travel=0;}
      travel+=Math.abs(delta);
      if(travel>=8){setAnnouncementHidden(direction>0&&y>announcementHeight);travel=0;}
    };
    const queueScroll=()=>{if(this.scrollFrame===null)this.scrollFrame=requestAnimationFrame(updateScroll);};
    if(group){
      window.addEventListener('scroll',queueScroll,{passive:true,signal:this.controller.signal});
      page?.addEventListener('scroll',queueScroll,{passive:true,signal:this.controller.signal});
    }
    const setOpen=open=>{this.dataset.open=String(open);toggle?.setAttribute('aria-expanded',String(open));const icon=toggle?.querySelector('[aria-hidden]');if(icon)icon.textContent=open?'\u00d7':'\u2630';if(shop)shop.open=open;syncViewport();};
    const close=()=>setOpen(false);
    this.on(toggle,'click',()=>setOpen(this.dataset.open!=='true'));
    this.on(document,'keydown',e=>{if(e.key==='Escape'&&(this.dataset.open==='true'||shop?.open)){const mobile=this.dataset.open==='true';close();(mobile?toggle:shop.querySelector('summary')).focus();}});
    this.on(document,'click',e=>{if(!this.contains(e.target))close();});
    this.on(this,'focusout',e=>{if(e.relatedTarget instanceof Element&&!this.contains(e.relatedTarget))close();});
    this.on(window,'resize',syncViewport);
    this.on(window.visualViewport,'resize',syncViewport);
    this.on(window.visualViewport,'scroll',syncViewport);
    this.resizeObserver?.disconnect();
    this.resizeObserver=new ResizeObserver(syncViewport);
    this.resizeObserver.observe(this);
    if(group)this.resizeObserver.observe(group);
    this.on(document,'shopify:section:load',syncViewport);
    this.on(document,'shopify:section:unload',()=>queueMicrotask(syncViewport));
    this.on(group,'focusin',e=>{if(e.target.closest('[data-lx-announcement]'))setAnnouncementHidden(false);});
    syncViewport();
  }
  disconnectedCallback(){
    super.disconnectedCallback();this.resizeObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);this.scrollFrame=null;
    if(this.stickyGroup){delete this.stickyGroup.dataset.lxAnnouncementHidden;this.stickyGroup.style.removeProperty('--lx-announcement-height');}
    if(!document.querySelector('lx-header'))document.documentElement.style.removeProperty('--lx-header-offset');
    document.documentElement.classList.remove('lx-menu-open');
  }
}
class LxSlideshow extends LxElement {
  mount(){
    this.slides=[...this.querySelectorAll('[data-slide]')];this.index=0;this.paused=this.dataset.autoplay!=='true'||lxMotion.matches;this.hover=false;this.focused=false;this.inView=false;
    this.observer?.disconnect();this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.sync();});this.observer.observe(this);
    this.on(this.querySelector('[data-next]'),'click',()=>this.show(this.index+1));
    this.on(this.querySelector('[data-prev]'),'click',()=>this.show(this.index-1));
    this.dots=[...this.querySelectorAll('[data-slide-dot]')];
    this.dots.forEach((dot,i)=>{this.on(dot,'click',()=>this.show(i));this.on(dot,'keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%this.dots.length;else if(e.key==='ArrowLeft')next=(i-1+this.dots.length)%this.dots.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=this.dots.length-1;else return;e.preventDefault();this.show(next);this.dots[next].focus();});});
    this.on(this.querySelector('[data-pause]'),'click',()=>{this.paused=!this.paused;this.sync();});
    this.on(this,'mouseenter',()=>{this.hover=true;this.sync();});this.on(this,'mouseleave',()=>{this.hover=false;this.sync();});
    this.on(this,'focusin',()=>{this.focused=true;this.sync();});this.on(this,'focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.sync();}));
    this.on(document,'visibilitychange',()=>this.sync());this.on(lxMotion,'change',()=>{if(lxMotion.matches)this.paused=true;this.sync();});
    this.on(document,'shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.show(i);}});this.show(0);
  }
  show(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>{s.hidden=i!==this.index;s.querySelectorAll('video').forEach(v=>{if(i!==this.index)v.pause();});});this.dots?.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));this.sync();}
  sync(){clearInterval(this.timer);const stopped=this.paused||this.hover||this.focused||!this.inView||document.hidden||lxMotion.matches;const b=this.querySelector('[data-pause]');if(b){b.setAttribute('aria-pressed',String(this.paused));const label=this.paused?lxStrings.play:lxStrings.pause;if(b.hasAttribute('data-icon-pause')){b.setAttribute('aria-label',label);b.title=label;}else b.textContent=label;}this.slides?.[this.index]?.querySelectorAll('video').forEach(v=>{if(stopped)v.pause();else v.play().catch(()=>{});});if(!stopped&&this.slides.length>1)this.timer=setInterval(()=>this.show(this.index+1),Math.max(2,Number(this.dataset.seconds)||6)*1000);}
  disconnectedCallback(){super.disconnectedCallback();clearInterval(this.timer);this.observer?.disconnect();this.querySelectorAll('video').forEach(video=>video.pause());}
}
class LxTabs extends LxElement {
  mount(){
    this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];
    this.tabs.forEach((tab,i)=>{this.on(tab,'click',()=>this.select(i));this.on(tab,'keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')next=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=this.tabs.length-1;else return;e.preventDefault();this.select(next);this.tabs[next].focus();});});
    this.on(document,'shopify:block:select',e=>{const panel=this.panels.findIndex(p=>p.contains(e.target)||p===e.target||(p.dataset.blockId&&p.dataset.blockId===e.detail?.blockId));if(panel>=0)this.select(panel);});
    this.querySelectorAll('[data-lx-swatch]').forEach(button=>{
      this.on(button,'focusin',e=>e.stopPropagation());
      this.on(button,'click',()=>this.selectColour(button));
    });
  }
  select(index){
    this.tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;});this.panels.forEach((p,i)=>p.hidden=i!==index);
    const link=this.querySelector('[data-view-all]'),url=this.tabs[index]?.dataset.collectionUrl;
    if(link){link.hidden=!url;if(url)link.setAttribute('href',url);else link.removeAttribute('href');}
  }
  selectColour(button){
    const card=button.closest('[data-lx-edit-card]');if(!card)return;
    const data=button.dataset,media=card.querySelector('.lx-card-media');
    card.querySelectorAll('[data-lx-swatch]').forEach(swatch=>{const selected=swatch===button;swatch.classList.toggle('is-selected',selected);swatch.setAttribute('aria-pressed',String(selected));});
    card.querySelectorAll('.lx-card-media,.lx-card-title').forEach(link=>link.setAttribute('href',data.variantUrl));
    if(data.image){
      const img=media.querySelector('img')||document.createElement('img'),width=Number(data.imageWidth),url=new URL(data.image,location.href);
      const widths=[160,320,480,750,1100].filter(candidate=>candidate<width);widths.push(width);
      img.sizes=media.dataset.imageSizes;
      img.srcset=widths.map(candidate=>{url.searchParams.set('width',String(candidate));return `${url.href} ${candidate}w`;}).join(', ');
      img.src=data.image;img.width=width;img.height=Math.round(width/Number(data.imageRatio));img.alt=data.imageAlt;img.loading='lazy';
      if(!img.parentElement)media.replaceChildren(img);
    }else{
      media.replaceChildren(card.querySelector('[data-lx-media-fallback]').content.cloneNode(true));
    }
    const quick=card.querySelector('quick-add-component');
    const input=quick?.querySelector('input[name=id]');if(input){input.value=data.variantId||'';input.disabled=!data.variantId||data.available!=='true';}
    if(!data.variantId&&quick?.querySelector('.quick-add__button--choose'))quick.dataset.quickAddButton='choose';
    if(data.variantId){
      const price=card.querySelector('.lx-card-meta span:last-child');if(price)price.textContent=data.price;
      const quantity=quick?.querySelector('input[name=quantity]');if(quantity)quantity.value=data.minQuantity;
      if(quick?.dataset.rendersBothButtons==='true'&&quick.dataset.usesSellingPlans!=='true'){
        quick.dataset.quickAddButton=data.available==='true'?'add':'choose';
        const add=quick.querySelector('.quick-add__button--add');if(add)add.disabled=data.available!=='true';
      }
    }
  }
}
class LxCardColours extends LxTabs {
  mount(){
    this.on(this,'focusin',event=>event.stopPropagation());
    this.on(this,'pointerdown',event=>{if(event.target.closest('[data-lx-swatch]'))event.stopPropagation();});
    this.on(this,'click',event=>{
      const button=event.target.closest('[data-lx-swatch]');
      if(!button||!this.contains(button))return;
      event.preventDefault();event.stopPropagation();this.selectColour(button);
    });
  }
}
class LxCarousel extends LxTabs {
  mount(){
    super.mount();
    this.tracks=[...this.querySelectorAll('[data-carousel-track]')];
    this.track=this.panels.length?this.panels.find(panel=>!panel.hidden)?.querySelector('[data-carousel-track]'):this.tracks[0];
    this.previous=this.querySelector('[data-carousel-prev]');this.next=this.querySelector('[data-carousel-next]');
    this.controls=this.querySelector('[data-carousel-controls]');this.gesture=null;this.blockClick=false;
    this.on(this.previous,'click',()=>this.step(-1));this.on(this.next,'click',()=>this.step(1));
    this.resizeObserver?.disconnect();this.resizeObserver=new ResizeObserver(()=>this.updateControls());
    this.tracks.forEach(track=>{
      this.on(track,'scroll',()=>{if(track===this.track)this.updateControls();});this.resizeObserver.observe(track);
      this.on(track,'keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.step(e.key==='ArrowRight'?1:-1);}});
      this.on(track,'pointerdown',e=>{
        if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,input,select,[data-lx-swatch]'))return;
        this.blockClick=false;this.gesture={id:e.pointerId,x:e.clientX,y:e.clientY,left:track.scrollLeft,dragged:false,track};
      });
      this.on(track,'pointermove',e=>{
        const g=this.gesture;if(!g||g.id!==e.pointerId)return;
        const x=e.clientX-g.x,y=e.clientY-g.y;
        if(!g.dragged){if(Math.max(Math.abs(x),Math.abs(y))<6)return;if(Math.abs(y)>Math.abs(x)){this.endDrag();return;}g.dragged=true;this.blockClick=true;track.dataset.dragging='true';track.setPointerCapture(e.pointerId);}
        e.preventDefault();track.scrollLeft=g.left-x;
      });
      this.on(track,'pointerup',()=>this.endDrag());this.on(track,'pointercancel',()=>this.endDrag());
      this.on(track,'lostpointercapture',()=>this.endDrag());
      this.on(track,'pointerleave',()=>{if(!this.gesture?.dragged)this.endDrag();});
      this.on(track,'dragstart',e=>e.preventDefault());
      track.addEventListener('click',e=>{if(this.blockClick){e.preventDefault();e.stopImmediatePropagation();this.blockClick=false;}},{capture:true,signal:this.controller.signal});
    });
    this.updateControls();
  }
  select(index){
    this.endDrag();super.select(index);this.track=this.panels[index]?.querySelector('[data-carousel-track]');this.updateControls();
  }
  step(direction){this.track?.scrollBy({left:direction*this.track.clientWidth,behavior:lxMotion.matches?'instant':'smooth'});}
  updateControls(){
    const max=this.track?this.track.scrollWidth-this.track.clientWidth:0,position=this.track?.scrollLeft||0;
    if(this.controls)this.controls.hidden=max<=2;
    [this.previous,this.next].forEach(button=>{if(!button)return;if(this.track)button.setAttribute('aria-controls',this.track.id);else button.removeAttribute('aria-controls');});
    if(this.previous)this.previous.disabled=position<=2;
    if(this.next)this.next.disabled=position>=max-2;
  }
  endDrag(){const g=this.gesture;if(!g)return;this.gesture=null;delete g.track.dataset.dragging;if(g.track.hasPointerCapture(g.id))g.track.releasePointerCapture(g.id);this.updateControls();}
  disconnectedCallback(){this.endDrag();this.resizeObserver?.disconnect();super.disconnectedCallback();}
}
class LxHotspots extends LxTabs {
  mount(){
    this.inView=false;this.optionStates=new WeakMap();
    this.observer?.disconnect();
    this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.syncPulse();});
    this.observer.observe(this);
    this.on(document,'visibilitychange',()=>this.syncPulse());
    this.on(lxMotion,'change',()=>this.syncPulse());
    this.querySelectorAll('[data-open]').forEach(button=>this.on(button,'click',()=>{
      const dialog=this.querySelector(`#${CSS.escape(button.dataset.open)}`);if(!dialog||dialog.open)return;
      const card=dialog.querySelector('[data-lx-edit-card]'),state=this.popupState(card);
      if(state&&!state.initialized){
        const initial=[...card.querySelectorAll('[data-option-position]')].find(item=>state.selected[Number(item.dataset.optionPosition)-1]===item.dataset.optionValue);
        if(initial)this.selectPopupOption(initial);state.initialized=true;
      }
      this.opener=button;this.activeDialog=dialog;
      button.setAttribute('aria-expanded','true');
      dialog.showModal();this.positionDialog();this.syncPulse();
      dialog.querySelector('[data-close]')?.focus({preventScroll:true});
    }));
    this.querySelectorAll('dialog').forEach(dialog=>{
      this.on(dialog.querySelector('[data-close]'),'click',()=>dialog.close());
      this.on(dialog,'click',e=>{
        const r=dialog.getBoundingClientRect();
        if(e.target===dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))dialog.close();
      });
      this.on(dialog,'close',()=>{
        if(this.activeDialog!==dialog)return;
        this.activeDialog=null;this.opener?.setAttribute('aria-expanded','false');
        this.syncPulse();this.opener?.focus({preventScroll:true});
      });
    });
    this.querySelectorAll('[data-lx-swatch]').forEach(button=>{
      this.on(button,'focusin',e=>e.stopPropagation());
      this.on(button,'click',()=>this.selectColour(button));
    });
    this.querySelectorAll('[data-lx-size]').forEach(button=>{
      this.on(button,'focusin',e=>e.stopPropagation());
      this.on(button,'click',()=>this.selectPopupOption(button));
    });
    this.querySelectorAll('.lx-popup-options').forEach(group=>{
      const card=group.closest('[data-lx-edit-card]'),state=this.popupState(card);
      if(state)this.updatePopupSizes(card,state);
    });
    this.on(window,'resize',()=>this.positionDialog());
    this.on(window,'scroll',()=>this.positionDialog());
    this.resizeObserver?.disconnect();
    this.resizeObserver=new ResizeObserver(()=>this.positionDialog());
    this.querySelectorAll('dialog').forEach(dialog=>this.resizeObserver.observe(dialog));
    this.syncPulse();
  }
  popupState(card){
    if(!card)return null;
    if(this.optionStates.has(card))return this.optionStates.get(card);
    const group=card.querySelector('.lx-popup-options'),template=group?.querySelector('[data-lx-popup-variants]');
    if(!template)return null;
    const state=JSON.parse(template.content.textContent);state.group=group;
    this.optionStates.set(card,state);return state;
  }
  selectColour(button){
    if(this.popupState(button.closest('[data-lx-edit-card]')))this.selectPopupOption(button);
    else super.selectColour(button);
  }
  selectPopupOption(button){
    const card=button.closest('[data-lx-edit-card]'),state=this.popupState(card);if(!state)return;
    const index=Number(button.dataset.optionPosition)-1;
    state.selected[index]=button.dataset.optionValue;state.optionIds[index]=button.dataset.optionId;
    const variant=state.variants.find(item=>item[1].every((value,i)=>value===state.selected[i]));
    const swatch=[...card.querySelectorAll('[data-lx-swatch]')].find(item=>state.selected[Number(item.dataset.optionPosition)-1]===item.dataset.optionValue);
    const displayButton=swatch||button,data=displayButton.dataset,url=new URL(state.group.dataset.productUrl,location.href);
    if(variant)url.searchParams.set('variant',String(variant[0]));
    else url.searchParams.set('option_values',state.optionIds.join(','));
    data.variantUrl=url.href;data.variantId=variant?String(variant[0]):'';
    data.available=String(Boolean(variant?.[2]));data.price=variant?.[3]||'';data.minQuantity=String(variant?.[4]||1);
    if(state.complete){
      const image=state.images.find(item=>item[0]===variant?.[5])||state.fallback;
      if(image){data.image=image[1];data.imageWidth=String(image[2]);data.imageRatio=String(image[3]);data.imageAlt=image[4];}
      else delete data.image;
    }
    super.selectColour(displayButton);
    const price=card.querySelector('.lx-card-meta span:last-child');
    if(price&&!variant)price.textContent=state.complete?state.group.dataset.unavailable:state.group.dataset.priceRange;
    const quick=card.querySelector('quick-add-component'),unavailable=state.complete&&!variant?.[2];
    quick?.querySelectorAll('.quick-add__button').forEach(action=>{action.disabled=unavailable;});
    if(!state.complete&&quick?.querySelector('.quick-add__button--choose'))quick.dataset.quickAddButton='choose';
    this.updatePopupSizes(card,state);
    state.group.querySelector('.lx-popup-availability').textContent=unavailable?(variant?state.group.dataset.soldOut:state.group.dataset.unavailable):'';
  }
  updatePopupSizes(card,state){
    card.querySelectorAll('[data-lx-size]').forEach(button=>{
      const index=Number(button.dataset.optionPosition)-1,value=button.dataset.optionValue;
      button.setAttribute('aria-pressed',String(state.selected[index]===value));
      const variant=state.variants.find(item=>item[1].every((option,i)=>option===(i===index?value:state.selected[i])));
      const unavailable=state.complete&&!variant?.[2];
      button.classList.toggle('is-unavailable',unavailable);
      button.setAttribute('aria-label',unavailable?`${value}, ${variant?state.group.dataset.soldOut:state.group.dataset.unavailable}`:value);
    });
  }
  syncPulse(){this.dataset.pulseActive=String(this.inView&&!document.hidden&&!lxMotion.matches&&!this.activeDialog?.open);}
  positionDialog(){
    const dialog=this.activeDialog;if(!dialog?.open||innerWidth<750)return;
    const r=this.opener.getBoundingClientRect(),bounds=dialog.getBoundingClientRect();
    const left=r.right+18+bounds.width<=innerWidth-16?r.right+18:r.left-bounds.width-18;
    dialog.style.left=`${Math.max(16,Math.min(innerWidth-bounds.width-16,left))}px`;
    dialog.style.top=`${Math.max(16,Math.min(innerHeight-bounds.height-16,r.top-30))}px`;
  }
  disconnectedCallback(){
    super.disconnectedCallback();this.observer?.disconnect();this.resizeObserver?.disconnect();
    this.activeDialog?.close();this.activeDialog=null;this.inView=false;this.syncPulse();
  }
}
class LxLook extends LxTabs {
  mount(){
    this.observer?.disconnect();
    const syncPulse=()=>{this.dataset.inView=String(this.inView&&!document.hidden);};
    this.inView=false;
    this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;syncPulse();});
    this.observer.observe(this);
    this.on(document,'visibilitychange',syncPulse);
    this.addEventListener('focusin',event=>{
      if(event.target.closest('[data-lx-swatch]'))event.stopPropagation();
    },{capture:true,signal:this.controller.signal});
    this.addEventListener('click',event=>{
      const swatch=event.target.closest('[data-lx-swatch]');
      if(swatch){event.stopPropagation();this.selectColour(swatch);return;}
      const button=event.target.closest('[data-select]');if(!button)return;
      const cards=[...this.querySelectorAll('.lx-look-card')];
      const card=cards.find(item=>item.id===button.dataset.select);if(!card)return;
      this.querySelectorAll('[data-select]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      cards.forEach(item=>item.classList.toggle('is-selected',item===card));
      card.focus({preventScroll:true});
      if(matchMedia('(max-width: 749px)').matches)card.scrollIntoView({behavior:lxMotion.matches?'instant':'smooth',block:'nearest',inline:'center'});
    },{capture:true,signal:this.controller.signal});
  }
  disconnectedCallback(){super.disconnectedCallback();this.observer?.disconnect();}
}
class LxMarquee extends LxElement {
  mount(){
    this.observer?.disconnect();this.resizeObserver?.disconnect();this.animation?.cancel();
    this.viewport=this.querySelector('.lx-marquee-window');this.track=this.querySelector('.lx-marquee-track');this.group=this.querySelector('.lx-social-group');this.button=this.querySelector('[data-pause]');
    if(!this.viewport||!this.track||!this.group)return;
    this.duration=(parseFloat(this.style.getPropertyValue('--duration'))||35)*1000;
    this.hover=false;this.focused=false;this.inView=false;this.gesture=null;this.blockClick=false;
    this.distance=this.group.getBoundingClientRect().width;
    this.animation=this.track.animate([{transform:'translateX(0)'},{transform:'translateX(-50%)'}],{duration:this.duration,iterations:Infinity,easing:'linear'});
    this.animation.pause();this.animation.currentTime=0;this.dataset.ready='true';this.dataset.dragging='false';
    this.on(this.button,'click',()=>{this.dataset.paused=String(this.dataset.paused!=='true');this.focused=false;this.sync();});
    this.on(this,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.sync();}});
    this.on(this,'pointerleave',e=>{if(e.pointerType==='mouse'){this.hover=false;this.sync();}});
    this.on(this,'focusin',e=>{
      this.focused=e.target.matches(':focus-visible');this.sync();
      if(this.focused&&e.target.closest('.lx-social-post')){
        this.viewport.scrollLeft=0;
        const bounds=e.target.getBoundingClientRect(),view=this.viewport.getBoundingClientRect();
        if(bounds.left<view.left||bounds.right>view.right)this.seek(bounds.left-this.track.getBoundingClientRect().left);
      }
    });
    this.on(this,'focusout',()=>queueMicrotask(()=>{if(!this.isConnected)return;this.focused=this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');this.sync();}));
    this.on(this.viewport,'pointerdown',e=>this.startDrag(e));
    this.on(this.viewport,'pointermove',e=>this.moveDrag(e));
    this.on(window,'pointerup',e=>this.endDrag(e));
    this.on(window,'pointercancel',e=>this.endDrag(e));
    this.on(this.viewport,'lostpointercapture',e=>this.endDrag(e));
    this.on(this.viewport,'dragstart',e=>e.preventDefault());
    this.on(this.viewport,'mousedown',e=>{if(e.button===0)e.preventDefault();});
    this.viewport.addEventListener('click',e=>{if(this.blockClick&&e.detail!==0){e.preventDefault();e.stopPropagation();this.blockClick=false;}},{capture:true,signal:this.controller.signal});
    this.on(document,'visibilitychange',()=>{if(document.hidden)this.endDrag();this.sync();});
    this.on(lxMotion,'change',()=>this.sync());
    this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;if(!this.inView)this.endDrag();this.sync();});this.observer.observe(this);
    this.resizeObserver=new ResizeObserver(()=>{const distance=this.group.getBoundingClientRect().width;if(distance!==this.distance){this.endDrag();this.distance=distance;}});this.resizeObserver.observe(this.viewport);
    this.sync();
  }
  position(){return ((Number(this.animation.currentTime)||0)%this.duration)/this.duration*this.distance;}
  seek(position){if(this.distance>0)this.animation.currentTime=((position%this.distance+this.distance)%this.distance)/this.distance*this.duration;}
  startDrag(e){
    if(!e.isPrimary||e.button!==0||this.gesture)return;
    this.blockClick=false;this.focused=false;
    this.gesture={id:e.pointerId,x:e.clientX,y:e.clientY,position:0,dragged:false};
    this.sync();this.gesture.position=this.position();
  }
  moveDrag(e){
    const gesture=this.gesture;if(!gesture||gesture.id!==e.pointerId)return;
    const x=e.clientX-gesture.x,y=e.clientY-gesture.y;
    if(!gesture.dragged){
      if(Math.max(Math.abs(x),Math.abs(y))<6)return;
      if(Math.abs(y)>=Math.abs(x)){this.endDrag(e);return;}
      gesture.dragged=true;this.blockClick=true;this.dataset.dragging='true';this.viewport.setPointerCapture(e.pointerId);
    }
    e.preventDefault();this.seek(gesture.position-x);
  }
  endDrag(e){
    const gesture=this.gesture;if(!gesture||(e&&gesture.id!==e.pointerId))return;
    this.gesture=null;this.dataset.dragging='false';
    if(gesture.dragged)this.hover=false;
    if(this.viewport.hasPointerCapture(gesture.id))this.viewport.releasePointerCapture(gesture.id);
    this.sync();
  }
  sync(){
    if(!this.animation)return;
    const paused=this.dataset.paused==='true'||lxMotion.matches;
    const stopped=paused||this.hover||this.focused||!!this.gesture||!this.inView||document.hidden;
    if(stopped)this.animation.pause();else this.animation.play();
    this.dataset.offscreen=String(!this.inView);this.dataset.documentHidden=String(document.hidden);
    if(this.button){this.button.hidden=false;this.button.disabled=lxMotion.matches;this.button.setAttribute('aria-pressed',String(paused));this.button.setAttribute('aria-label',paused?lxStrings.play:lxStrings.pause);}
  }
  disconnectedCallback(){
    super.disconnectedCallback();this.endDrag();this.animation?.cancel();this.observer?.disconnect();this.resizeObserver?.disconnect();delete this.dataset.ready;if(this.button)this.button.hidden=true;
  }
}
class LxGallery extends LxElement {
  mount(){const gallery=this.querySelector('[data-gallery]'),buttons=[...this.querySelectorAll('[data-gallery-go]')];buttons.forEach((b,i)=>this.on(b,'click',()=>gallery?.scrollTo({left:i*gallery.clientWidth,behavior:lxMotion.matches?'instant':'smooth'})));this.on(gallery,'scroll',()=>{const index=Math.round(gallery.scrollLeft/gallery.clientWidth);buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));});}
}
[['lx-header',LxHeader],['lx-slideshow',LxSlideshow],['lx-tabs',LxTabs],['lx-card-colours',LxCardColours],['lx-carousel',LxCarousel],['lx-hotspots',LxHotspots],['lx-look',LxLook],['lx-marquee',LxMarquee],['lx-gallery',LxGallery]].forEach(([name,element])=>{if(!customElements.get(name))customElements.define(name,element);});
  } catch(e) { console.error(e); }
})();

})();
